// es/channel.js
export const channel = {
  header: {
    title: "Canales de reserva",
    subtitle:
      "Sincroniza o gestiona Booking.com, Expedia, Airbnb y muchos más.",
  },

  establishedConnections: "Conexiones establecidas",

  common: {
    loading: "Cargando...",
    configure: "Configurar",
    close: "Cerrar",
    comingSoon: "Próximamente",
  },

  alerts: {
    bullets: {
      choosePlan: "Elige un plan y activa tu Channel Manager.",
      completeProperty: "Completa la conexión de tu alojamiento en el panel.",
    },
    title: "Acción requerida",
    planRequired:
      "Debes estar suscrito a un plan activo para vincular tu alojamiento con una OTA.",
    missingPropertyChannel:
      "Para vincular con una OTA necesitas completar la conexión de tu alojamiento en el Channel Manager.",
  },

  modal: {
    channelHeader: "Conexión con el canal {channel}",
  },

  web: {
    cardTitle: "Reservas directas",
    // NUEVO: descripción para el card tipo OTA
    cardDescription:
      "Recibe reservas directas desde tu web sin comisiones de OTA.",
    // NUEVO: textos de botones para el card y la tabla
    manageCta: "Administrar",
    configureCta: "Configurar",
    // NUEVO: texto para la columna ID CONEXIÓN de la fila de reservas directas
    directLinkLabel: "Link reserva directa",

    linkShareMessage:
      "Hola 👋, bienvenido/a. Puedes realizar tu reserva desde el siguiente enlace:\n\n{link}",
    modalTitle: "Reservas directas vía web",
    description:
      "Activa o desactiva las opciones que estarán disponibles para reserva directa en tu página web. Los huéspedes podrán reservar directamente sin intermediarios.",
    toggleAllDesktop: "Activar/Desactivar todas las reservas vía web",
    toggleAllMobile: "Activar/Desactivar",
    table: {
      name: "Nombre",
      available: "Disponible para reserva web",
    },
    capacity: "Capacidad",
    people: "personas",
    empty: "No se encontraron elementos para mostrar",

    // Sección de enlace
    linkTitle: "Tu enlace de reservas directas",
    linkHelp:
      "Comparte este enlace para que tus huéspedes puedan reservar directamente",
    linkCopyTooltip: "Copiar enlace",
    linkShareWhatsappTooltip: "Compartir en WhatsApp",
  },

  plan: {
    title: "Activar tu plan para conectar",
    subtitle:
      "Selecciona el plan que se ajuste a tus necesidades y habilita la conexión con Booking, Airbnb, Expedia y más.",
    hint: "Una vez que te suscribas, vuelve aquí; desbloquearemos todos los canales con los que puedes conectarte.",
    cta: "Actualizar plan",
  },

  toasts: {
    paymentTypeUpdated: "Tipo de pago actualizado correctamente",
    linkCopiedTitle: "¡Copiado!",
    linkCopiedBody: "El enlace se copió con éxito",
    linkCopyErrorTitle: "Error",
    linkCopyErrorBody: "Hubo un error al copiar el enlace",
    save: "Error al guardar la configuración",
    updateWebReservation: "Error al actualizar la reserva web",
    saved: "Configuración guardada correctamente",
    updateWebReservationsGlobal:
      "Estado global de las reservas directas actualizado correctamente",
  },

  errors: {
    loadData: "Error al cargar los datos. Por favor, inténtalo nuevamente.",
    generateToken: "Error al generar token",
    connectChannel:
      "Error al conectar con el canal. Por favor, inténtalo nuevamente.",
    updatePaymentType: "Error al actualizar el tipo de pago",
    save: "Error al guardar la configuración",
    updateWebReservation: "Error al actualizar la reserva web",
  },

  tabs: {
    reservations: "Estado de Reservas",
    payments: "Precios y Pagos",
    share: "Compartir",
  },

  payments: {
    title: "¿Cómo deseas que te paguen las reservas directas?",
    onArrival: {
      label: "Pago en el alojamiento",
      desc: "Los huéspedes pagarán directamente al llegar",
    },
    online: {
      label: "Pago online anticipado",
      desc: "Los huéspedes pagarán al hacer la reserva",
    },
  },

  discounts: {
    sectionTitle: "Configurar descuento para reservas directas",
    toggle: "Aplicar descuento a reservas directas",
    typeTitle: "Tipo de descuento:",
    percentage: {
      label: "Descuento por porcentaje",
      desc: "Aplica un porcentaje de descuento",
    },
    fixed: {
      label: "Descuento precio fijo",
      desc: "Aplica un descuento de cantidad fija",
    },
    valueTitle: "Valor del descuento:",
    placeholderPercentage: "Ej: 10",
    placeholderFixed: "Ej: 50.00",
    helpPercentage:
      "Ingresa un valor entre 1 y 100 para el porcentaje de descuento",
    helpFixed: "Ingresa el valor fijo en euros que se descontará del total",
    previewTitle: "Vista previa:",
    previewPercentage:
      "Se aplicará un {value}% de descuento a las reservas directas",
    previewFixed:
      "Se aplicará un descuento de €{value} a las reservas directas",
  },

  buttons: {
    saveChanges: "Guardar cambios",
  },
};
